<template>
  <div>
    <v-autocomplete
      v-model="selectedItem"
      :items="lista"
      :item-text="itemText"
      :item-value="itemValue"
      :placeholder="`Selecionar ${rotulo}`"
      :hint="rotulo"
      :rules="rules"
      :size="size"
      clearable
      @change="updateValue"
      @keydown="updateSearch"
      class="text-caption"
      persistent-hint
      return-object
      single-line
      outlined
      dark
      dense
      multiple
      filled
      chips
      ><template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.DESCRICAO }}</span>
        </v-chip>
        <span v-if="index === 1" class="grey--text caption">
          (+{{ size - 1 }} outros)
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    itemValue: {
      type: String,
      default: "CODIGO",
    },
    itemText: {
      type: String,
      default: "DESCRICAO",
    },
    rotulo: {
      type: String,
      default: "",
    },
    lista: {
      type: Array,
      default: () => [],
    },
    item: {
      type: [Object, String, Array],
      default: () => {},
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    selectedItem: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update:item", val);
      },
    },
    rules() {
      const rules = [];
      if (this.isRequired) {
        const rule = (value) => !!value || "Campo Obrigatório.";
        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    updateSearch(value) {
      this.$emit("searchinput", value);
    },
  },
};
</script>

<style></style>template>
